import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { checkUserAuth } from "../../services/auth/authSlice";
import { IS_NATIVE, nativeSamlLogin } from "../../services/auth/nativeAuth";
import { API_URL } from "../../config/constants";
import { SaveToLocalStorage } from "../../utils/utils";

// SAML login (web redirect or native webview), with a loader flag until the university login page shows up
export default function useSamlLogin () {
    const t = useSelector(selectTranslations);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [samlLoading, setSamlLoading] = useState(false)

    // web: back from the university page restores this page from the bfcache, with the loader still on
    useEffect(()=>{
        const reset = (e) => e.persisted && setSamlLoading(false)
        window.addEventListener('pageshow', reset)
        return () => window.removeEventListener('pageshow', reset)
    },[])

    const startSamlLogin = () => {
        if (samlLoading) return
        setSamlLoading(true)
        if (IS_NATIVE) return nativeSamlLogin(t.login.saml_in_progress).then(({error, cancelled, manualAccessToken}) => {
            setSamlLoading(false)
            if (cancelled) return
            if (error) return navigate(`/error_page?msg=${error}`)
            if (manualAccessToken !== undefined) return navigate(`/manual_access_request?token=${encodeURIComponent(manualAccessToken)}`)
            // same as the web return: verify the session (and get a fresh token) via refresh_session
            SaveToLocalStorage('refresh_auth', true)
            dispatch(checkUserAuth())
        })
        // the SAML callback sets the auth cookie and redirects back to the app:
        // the flag makes the app verify it on return (see checkUserAuth in App.js)
        SaveToLocalStorage('refresh_auth', true)
        window.location.href = `${API_URL}/start_saml_login`
    }

    return [startSamlLogin, samlLoading]
}
